import { IconButton } from '@lokalise/louis';
import { css, modifier, styled, variants } from '@lokalise/styled';

import { color, radius, spacing, typography } from '@app/theme';

export const InlineValueEditorContainer = styled.div<{
    $editable?: boolean;
    $editing?: boolean;
    $error?: boolean;
}>`
    display: inline-flex;
    align-items: center;
    gap: ${spacing(2)};
    ${typography('body.small.strong')}

    & > button {
        visibility: hidden;
    }

    ${modifier(
        '$editable',
        css`
            &:hover > button {
                visibility: visible;
            }
        `,
    )}

    ${modifier(
        '$editing',
        css`
            border-radius: ${radius('m')};
            outline: ${color('border.active')} solid 1px;
        `,
    )}

    ${modifier(
        'error',
        css`
            outline: none;
        `,
    )}
`;

export const InlineValueEditorIconButton = styled(IconButton)<{
    variant: 'primary' | 'secondary';
}>`
    ${variants('variant', {
        primary: css`
            background-color: ${color('background.action.primary.default')};
            color: ${color('text.inverse')};

            &:hover:not([disabled]),
            &:focus-visible:not([disabled]) {
                background-color: ${color('background.action.primary.hover')};
                color: ${color('text.inverse')};
            }

            &:active:not([disabled]) {
                background-color: ${color('background.action.primary.pressed')};
                color: ${color('text.inverse')};
            }
        `,
        secondary: css`
            border: 1px solid ${color('border.active')};
            color: ${color('text.link.default')};

            &:hover:not([disabled]),
            &:focus-visible:not([disabled]) {
                color: ${color('text.link.hover')};
            }

            &:active:not([disabled]) {
                color: ${color('text.active')};
            }
        `,
    })}
`;
